import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsentComponent } from './components/access/consent/consent.component';
import { LoggedOutComponent } from './components/access/logged-out/logged-out.component';
import { NotFoundComponent } from './components/access/not-found/not-found.component';
import { SessionTimedOutComponent } from './components/access/session-timed-out/session-timed-out.component';
import { CaseDetailComponent } from './components/cases/case-detail/case-detail.component';
import { CaseListComponent } from './components/cases/case-list/case-list.component';
import { ComplaintFormComponent } from './components/forms/complaint-form/complaint-form.component';
import { FeedbackFormComponent } from './components/forms/feedback-form/feedback-form.component';
import { IntroductionComponent } from './components/introduction/introduction.component';
import { SelectComponent } from './components/select/select.component';
import { ContactInvitationComponent } from './components/contact-invitation/contact-invitation.component';
import { AccessDeniedComponent } from './components/access/access-denied/access-denied.component';
import { FaqComponent } from './components/faq/faq.component';
import { canDeactivateGuard } from './guards/case-changed.guard';
import { ContactInvitationApproveComponent } from './components/contact-invitation/contact-invitation-approve/contact-invitation-approve/contact-invitation-approve.component';
import { SelectLoginComponent } from './components/select-login/select-login.component';
import { LoginComponent } from './components/login/login.component';

const routes: Routes = [
  { path:'introduction', component: IntroductionComponent },
  { path:'select/:complaintType', component: SelectComponent },

  { path:'login/:complaintType/:attemptResolved/:attemptSettlement', component: SelectLoginComponent },

  { path:'form', component: ComplaintFormComponent },
  { path:'form/:complaintType/:attemptResolved/:attemptSettlement', component: ComplaintFormComponent, canDeactivate: [canDeactivateGuard] },
  { path:'form/feedback', component: FeedbackFormComponent },

  { path: 'access/login', component: LoginComponent },
  { path: 'access/loggedout', component: LoggedOutComponent },
  { path: 'access/idle', component: SessionTimedOutComponent },
  { path: 'access/notfound', component: NotFoundComponent },
  { path: 'access/consent/:id', component: ConsentComponent },
  { path: 'access/denied', component: AccessDeniedComponent },

  { path: 'contactinvitation/:id/:caseUid/:type', component: ContactInvitationComponent},
  { path: 'contactinvitation/:id/:caseUid/:type/approve', component: ContactInvitationApproveComponent},

  { path:'cases', component: CaseListComponent },
  { path:'cases/:id', component: CaseDetailComponent, canDeactivate: [canDeactivateGuard] },

  { path: 'faq', component: FaqComponent },

  { path: '', redirectTo: '/introduction', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
